import React from "react";
import { NavLink } from "react-router-dom";
import { useConsent } from "@/context/ConsentContext";
import { useI18n } from "@/context/I18nContext";

export default function CookieBanner() {
  const { t, lang } = useI18n();
  const { showBanner, setConsent } = useConsent();

  if (!showBanner) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      role="dialog"
      aria-live="polite"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-slate-200 bg-white shadow-2xl"
    >
      <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-5 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:gap-8 lg:px-10">
        <div className="max-w-3xl">
          <p className="font-heading text-sm font-semibold text-slate-900">
            {t("cookie_banner.title")}
          </p>
          <p className="mt-1 text-sm leading-relaxed text-slate-600">
            {t("cookie_banner.description")}{" "}
            <NavLink
              to={`/${lang}/cookies`}
              data-testid="cookie-banner-policy-link"
              className="font-semibold text-emerald-700 underline underline-offset-2"
            >
              {t("cookie_banner.policy_link")}
            </NavLink>
            .
          </p>
        </div>
        <div className="flex flex-col gap-2 sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={() => setConsent(false)}
            data-testid="cookie-banner-decline-btn"
            className="rounded-md border border-slate-300 bg-white px-4 py-2.5 text-sm font-semibold text-slate-800 hover:bg-slate-50"
          >
            {t("cookie_banner.decline")}
          </button>
          <button
            type="button"
            onClick={() => setConsent(true)}
            data-testid="cookie-banner-accept-btn"
            className="rounded-md bg-emerald-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-emerald-700"
          >
            {t("cookie_banner.accept")}
          </button>
        </div>
      </div>
    </div>
  );
}
